import React from "react";
import { Alert } from "@material-ui/lab";
import { StyledScrollTable, StyledTable, StyledTableBody, StyledTableHead } from "../../../styles/styledTable";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import TelegramChatsItem from "./TelegramChatsItem";

const TelegramChatsList = ({ chats, onToggled, setNotification, t }) => {
  if (chats === null) {
    return <PageSpinner position="center" pt="20" pb="20" />;
  }

  if (chats.length === 0) {
    return <Alert severity="warning">{t("chats.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable width="900" size="14" className="chat-list">
        <StyledTableHead scroll="auto" col="6" className="chat-list__head">
          <div>{t("chats.table.status")}</div>
          <div>{t("chats.table.id")}</div>
          <div>{t("chats.table.telegramChatId")}</div>
          <div>{t("chats.table.title")}</div>
          <div>{t("chats.table.project")}</div>
          <div>{t("chats.table.createdAt")}</div>
        </StyledTableHead>
        <StyledTableBody>
          {chats.map(chat => (
            <TelegramChatsItem key={chat.id} chat={chat} onToggled={onToggled} setNotification={setNotification} t={t} />
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};

export default TelegramChatsList;